// extracted by mini-css-extract-plugin
module.exports = {"forms-dashboard-spinner":"dashboard_forms-dashboard-spinner__2WLCl"};